module.exports = __webpack_public_path__ + "media/images/technopark/custom_link-82430e744323f1c82c299c7ed03bc62d.png";